import * as React from 'react';
import * as styles from './commentForm.css';

import { SaveButton } from '../SaveButton';
import { IUpdateNoteParams } from '../../actions/favoriteEntities/notes';
import { AutoHeightTextarea } from '../AutoheightTextarea';
import { CancelCommentContainer } from '../../containers/CancelCommentContainer';

export interface ICommentFormProps {
  entityId: number;
  isFetching: boolean;
  comment?: string | null;
  onSubmitComment(params: IUpdateNoteParams): void;
}

export interface ICommentFormState {
  comment: string;
}

export class CommentForm extends React.PureComponent<ICommentFormProps, ICommentFormState> {
  public constructor(props: ICommentFormProps) {
    super(props);

    this.state = {
      comment: this.props.comment || '',
    };
  }

  public render() {
    const { entityId, isFetching } = this.props;
    const { comment } = this.state;

    return (
      <form className={styles.comment_form} onSubmit={this.onSubmit}>
        <AutoHeightTextarea comment={comment} onChange={this.onChange} />
        <div className={styles.comment_controls}>
          <SaveButton type="submit" isFetching={isFetching} />
          <CancelCommentContainer entityId={entityId} />
        </div>
      </form>
    );
  }

  private onChange = ({ currentTarget: { value } }: React.SyntheticEvent<HTMLTextAreaElement>) => {
    this.setState({ comment: value });
  };

  private onSubmit = (event: React.SyntheticEvent<HTMLFormElement>) => {
    const { entityId, onSubmitComment } = this.props;
    const { comment } = this.state;

    event.preventDefault();
    event.stopPropagation();
    onSubmitComment({ comment, entityId });
  };
}
